// Aides DOM sans métier : insertion progressive des longues listes (catalogue, QCM).
window.renderRowsProgressive = function(el, rows, first, chunk) {
    if (!el) return;
    var token = (window._rowsToken = (window._rowsToken || 0) + 1);
    // Progressif seulement à la première peinture : un redessin pose tout d'un coup, sans lignes qui apparaissent par paquets.
    if (window.__premierRenduFait) { el.innerHTML = rows.join(''); return; }
    el.innerHTML = rows.slice(0, first).join('');
    if (rows.length <= first) return;
    var i = first, tag = el.tagName === 'TBODY' ? 'tbody' : 'div';
    var step = function() {
        if (token !== window._rowsToken || !el.isConnected) return;
        var tmp = document.createElement(tag);
        tmp.innerHTML = rows.slice(i, i + chunk).join('');
        while (tmp.firstChild) el.appendChild(tmp.firstChild);
        i += chunk;
        if (i < rows.length) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const renderRowsProgressive = window.renderRowsProgressive;
